app.service('basketView', function (console, orderUtils, partnerSubscriptionManager, pageConfig, carouselSlider,
	basketServices, basketWarranty, broker, basketProduct, basketUtils, basketAnalytics, basketServiceReminder,
	basketPackageModal, basketStandaloneService, basketPartnerSubscription, basketFocus, kredytLineRedirect, cartRetrieve,
	basketDeliveryUnavailable, basketRetrieveCart, csrfToken, basketHomeDelivery, relatedAccessories, instalmentOrderAction,
	loading, validate, modal, basketVoucher, basketShare, basketServicesModal, simpleToastr, message, expandableMessage, log, basketBundle,
	warrantyQuestionnaire, allAccesoriesModal, partnerInsurance, instalmentCalculatorModal, deliveryPoints,
	operatorMaxWorthCalculator, goBack, callback, basketDependentProduct, html, basketAccessories,
	newBasketServiceReminder) {
	var $self, $path, $deliveryType, $orderRequireActionModal, $shopPaymentType;
	var config, basket;
	let isOneInit = false;
	let savedFocusParams = false;

	function next(forced = false) {
		console.log('DALEJ NA KOSZYKU');
		if (basketVoucher.check(next)) {
			return;
		}
		if ($form.valid()) {
			if (config.isOperatorMode && !config.deliveryMode && !forced) {
				if (!warrantyQuestionnaire.updateWarrantyQuestionnaireBeforeSent(function(){
					next(true);
				})) {
					return false;
				}
			}
			if (config.isPartnerMode && forced == false && !(html.has('new-delivery') && !config.deliveryMode)) {	// nie pokazujemy na k1 kiedy jest nowa ścieżka
				if (!partnerInsurance.checkNext(function () {
					next(true);
				})) {
					return false;
				}
			}
			if (html.has('new-delivery') && !config.deliveryMode) {
				loading.redirect({
					href: '/cart-delivery.bhtml',
					soft: config.isUserLogged && config.keycloakEnabled ? true : false
				});
				return;
			}
			if (html.has('new-delivery') && config.deliveryMode) {
				if (config.deliveryType == 0 || config.deliveryType == 2 || config.deliveryType == 4) {
					if (!config.deliveryPoint) {
						deliveryPoints.show();
						return;
					}
				}
			}
			basketVoucher.logVouchersOnSend();
			if (config.instalmentOrdersRequiringNext && $orderRequireActionModal.length) {
				instalmentOrderAction.open();
			} else if (config.showNotAddedServices) {
				if (html.has('new-services-reminder') && config.deliveryMode) {
					newBasketServiceReminder.open();
				} else {
					basketServiceReminder.open();
				}
			} else {
				if (checkCart()) {
					send();
				}
			}
		}
	}

	function closeInstalmentOrdersAction() {
		if (config.instalmentOrdersRequiringNext) {
			config.instalmentOrdersRequiringNext = false;
			next();
		}
	}
	function send() {
		orderUtils.send('CREATE_ORDER');
	}
	function back() {
		if (config.deliveryMode) {
			loading.redirect({
				href: '/cart.bhtml',
				soft: true
			});
		} else {
			goBack.go();
		}
	}
	function checkCart() {
		if (config.serviceNotify) {
			console.log('POTYKACZ USŁUG');
			basketDeliveryUnavailable.open();
			return false;
		}
		else if (config.promoteDelivery) {
			console.log('POTYKACZ DOSTAWY');
			basketHomeDelivery.open();
			return false;
		} else {
			return true;
		}
	}
	function showMessages() {
		if (config.messages && config.messages.length) {
			$(config.messages).each(function (i, message) {
				console.log('komunikat: ' + (message.type && message.type.length ? message.type : 'brak typu'));
				if (message.type == 'CART_ITEM_DEPEND_PRODUCTS_GROUP') {
					modal.generate({
						id: 'modal-' + message.type.toLowerCase(),
						modifier: 'simple-basket-modal',
						content: message.content,
						buttons: [
							{
								text: 'Rozumiem',
								click: function () {
									modal.close();
								}
							}
						]
					});
				} else {
					basketAnalytics.addProductErrorInit('cart-max-product-count-message');
					modal.addMessage(message.content, message.type);
				}
			});
			config.messages = [];
			modal.showMessages();
		}
	}
	function reloadCartSuccess(htmlResponse, deliveryType = null) {
		modal.removeRemodals();
		if (htmlResponse.indexOf('"order-path"') > -1 || htmlResponse.indexOf('"order-path-native-app"') > -1) {		// cart.bhtml jako odpowiedź
			var $html = $('<div>' + htmlResponse + '</div>');
			const $htmlPath = $html.find('.order-path-' + (html.has('new-delivery') ? 'new' : 'old') + ', #order-path-native-app');
			$path.html($htmlPath.html()).attr('class', $htmlPath.attr('class'));
			$self.html($html.find('#container').html());
			const newUrl = $html.find('meta[name="nice"]').attr('value');
			if (newUrl != window.location.pathname) {
				window.history.pushState({ url: newUrl }, '', newUrl);
			}
		} else if (htmlResponse.indexOf('id="main-column"') > -1) {	// cart-only-body.bhtml jako odpowiedź np zmiana/potwierdzenie usługi
			$self.html(htmlResponse);
		} else {
			$self.find('article#main-column').html(htmlResponse);		// DO wyjaśnienia czy taki warunek faktycznie istnieje i jest potrzebny
		}
		init();
		restoreCsrfToken();
		UA.pageview();
		if (deliveryType !== null) {
			setDeliveryType(deliveryType);
		}
		if (config.isOperatorMode) {
			warrantyQuestionnaire.markAnswers();
		}
		loading.stop();
		broker.trigger('RELOAD_CART_SUCCESS');
		broker.trigger('WDIO-PAGE-REFRESH');
		callback.run('BASKET_RELOAD');
	}
	
	function restoreCsrfToken() {
		if (config.deliveryMode && $form.length && !$('input[name="_csrf"]', $form).length) {
			csrfToken.get(function (csrf_token) {
				$('<input>').attr({ type: 'hidden', name: '_csrf', value: csrf_token }).appendTo($form);
			});
		}
	}

	var isBasketReload = false;
	function reloadCartView(callback) {
		if (!isBasketReload) {
			isBasketReload = true;
			loading.start();
			$('#F_ACTION').val('REFRESH');
			$.ajax({
				cache: false,
				url: '/cart-only-body.bhtml?deliveryMode=' + config.deliveryMode,
				data: $form.serialize(),
				type: 'POST',
				success: function (html) {
					reloadCartSuccess(html);
					isBasketReload = false;
					if (callback) {
						callback();
					}
				},
				error: function () {
					loading.stop();
					modal.alert('Wystąpił błąd przeładowania koszyka. Spróbuj ponownie odświeżyć koszyk');
					isBasketReload = false;
				}
			});
		}
	}
	function reloadDelivery(action, deliveryType, callback) {
		loading.start();
		basketUtils.incBacks();
		if (action) {
			$('#F_ACTION').val(action);
		}
		var data = $form.serializeArray();
		if (action && deliveryType == 0 || deliveryType == 1) {
			data.forEach(function (e) {
				if (e.name == 'deliveryType') {
					e.value = '' + deliveryType;
				} else if (deliveryType == 0 && e.name == 'shopDeliveryOptionType') {
					e.value = e.value;
				} else if (deliveryType == 1 && e.name == 'shopDeliveryOptionType') {
					e.value = '';
				}
			})
		}
		$.ajax({
			cache: false,
			url: config.deliveryMode ? '/cart-delivery.bhtml' : '/cart.bhtml',
			data: data,
			type: 'POST',
			success: function (html) {
				savedFocusParams = { type: 'change-delivery-type', deliveryType: deliveryType, shopType: $shopPaymentType.val() };
				broker.trigger('BEFORE_PAGE_CHANGE');
				reloadCartSuccess(html, deliveryType);
				if (callback) {
					callback();
				}
			},
			error: function () {
				loading.stop();
				modal.alert('Wystąpił błąd przeładowania koszyka. Koszyk zostanie przeładowany', function () {
					loading.reload({ soft: true });
				});
			}
		});
	}
	function setShopPaymentType(deliveryType) {
		$shopPaymentType.val(deliveryType);
	}
	function updateDeliveryType(deliveryType, callback) {
		reloadDelivery('CHANGE_DELIVERY_TYPE', deliveryType, callback);
	}
	function setDeliveryType(deliveryType) {
		config.deliveryType = parseInt(deliveryType);
		if (config.deliveryType !== 0) {
			setShopPaymentType("");
		}
		$deliveryType
			.filter('[value=' + deliveryType + ']')
			.filter(checkIfShopDeliveryMatchesPaymentOnline)
			.prop('checked', true);
	}
	function checkIfShopDeliveryMatchesPaymentOnline() {
		if (config.deliveryType === 0) {
			return $(this).data('shop-payment-type') === config.shopDeliveryOptionType;
		}
		return true;
	}
	var viewedPromotionProposals = [];
	function setPromotionProposalsUA() {
		var $promotionProposals = $('.promotion-proposal');
		if ($promotionProposals.length > 0) {
			$promotionProposals.each(function (i, el) {
				var promotionName = $(el).find('.promotion-name').text();
				var promotionUrl = $(el).find('.js-check-promotion').attr('href');
				if (!viewedPromotionProposals.includes(promotionName)) {
					UA.push({
						'event': 'view_promotion',
						'promotion_name': promotionName,
						'creative_name': 'Promocja na koszyku',
						'promotion_url': promotionUrl,
					});
					viewedPromotionProposals.push(promotionName);
				}
				$(el).on('click', '.js-check-promotion', function () {
					basketAnalytics.promotionClick(promotionName, promotionUrl);
				});
			})
		}
	}
	function setElements() {
		$self = $('#basket #container');
		console.log('INIT BASKET', $self);
		$form = $('#front-form', $self);
		$path = $('#order-path, #order-path-native-app');
		$deliveryType = $('.js-delivery-type', $form);
		$orderRequireActionModal = $('#modal-instalment-orders-requiring-actions');
		$productSlider = $('.product-slider', $self);
		$shopPaymentType = $('#shop-payment-type');
		config = pageConfig.getData('order');
		basket = pageConfig.getData('basket');
		if (html.has('new-services')) {
			$('.product-box > .services').remove();
			$('.product-box > .warranties').remove();
		} else {
			$('.product-box > .product-slider').remove();
			$('.product-box > .warranties-questionnaire').remove();
		}
		if (html.has('new-accessories')) {
			$('.product-box > .related-accessories').remove();
		} else {
			$('#basket-accessories').remove();
		}
		if (html.has('new-services')) {
			$('.product-box > .promotion-proposal').remove();
		} else {
			// nic
		}

		if (html.has('new-product-box')) {
			// nic
		} else {
			$('#basket .product-remove').remove();
		}
	}
	function showMaxCountMessage(maxCount, mainId, bundle) {
		var ending = maxCount == 1 ? 'sztukę' : (maxCount < 5 || (maxCount > 20 && maxCount % 10 >= 2 && maxCount % 10 < 5)) ? 'sztuki' : 'sztuk';
		var headerHtml = `Możesz kupić maksymalnie ${maxCount} ${ending} tego produktu`;
		let messageCode = 'cart-max-product-count-message';

		if (bundle) {
			basketProduct.maxBundleQuantity(mainId);
			return;
		} if (config.isOperatorMode) {
			messageCode = 'cart-max-product-count-message - tryb operatorski';
		} else if (config.isPartnerMode) {
			messageCode = 'cart-max-product-count-message - tryb partnerski';
		}

		message.get(messageCode).then(function (result) {
			modal.generate({
				id: 'modal-product-max-count',
				header: headerHtml,
				content: result
			});

			basketAnalytics.addProductError(mainId, messageCode);
		});
	}
	function isProductInstallmentPrice(productId) {
		return basket.items.filter(item => item.id == productId / 1)[0].isInstalmentPrice
	}

	function setEvents() {
		relatedAccessories.init();
		if ($productSlider.length) {
			$productSlider.each(function () {
				carouselSlider.init($(this).find('.carousel-slider'));
			});
		}
		if (config.isOperatorMode) {
			warrantyQuestionnaire.init();
		}
		$('.js-select-delivery-point').on('click', function (event) {
			event.preventDefault();
			event.stopPropagation();

			const $this = $(this);
			deliveryPoints.show({
				latitude: $this.data('latitude'),
				longitude: $this.data('longitude'),
				selectedPoint: $this.data('shop') || $this.data('point')
			});

		});
		$('.js-share-basket').on('click', function (event) {
			event.preventDefault();
			basketShare.run();
		});
		$('.js-open-package-modal').on('click', function (event) {
			event.preventDefault();
			basketPackageModal.open($(this).data('main'));
		});

		$('.js-increase-product', $self).click(function () {
			const $input = $(this).prev();
			const value = parseInt($input.val()) + 1;
			const mainId = $input.data('main');
			const bundle = $input.data('bundle-limit');
			const max = $input.data('max') / 1;
			const maxProduct = $input.data('max-product') / 1;
			if (value > max) {
				showMaxCountMessage(maxProduct, mainId, bundle);
				$input.val(max);
			} else {
				basketProduct.increase(value, mainId, bundle, { type: 'increase-product', main: mainId });
			}
		});

		$('.js-decrease-product', $self).click(function () {
			const $input = $(this).parent().find('.js-change-quantity').first();
			const value = parseInt($input.val()) - 1;
			const mainId = $input.data('main');
			basketProduct.decrease(value, mainId, { type: 'decrease-product', main: mainId });
		});


		$('.js-increase-partner-subscription-standalone-service', $self).click(function () {
			const $input = $(this).parent().find('.js-change-partner-subscription-standalone-service-quantity');
			const quantity = parseInt($input.val()) + 1;
			$input.val(quantity);
			const productId = $input.data('product-id');
			basketStandaloneService.update({
				productId,
				quantity
			});
		});

		$('.js-decrease-partner-subscription-standalone-service', $self).click(function () {
			const $input = $(this).parent().find('.js-change-partner-subscription-standalone-service-quantity');
			const quantity = parseInt($input.val()) - 1;
			$input.val(quantity);
			const productId = $input.data('product-id');
			basketStandaloneService.update({
				productId,
				quantity
			});
		});

		function enableAutoVouchers() {
			loading.start();
			return $.ajax({
				method: 'POST',
				url: '/enableAutomaticVouchers.ltr',
				success: function () {
					broker.trigger('REFRESH_BASKET_VIEW');
				},
				error: function () {
					modal.alert('Błąd aktywacji. Spróbuj ponownie po odświeżeniu');
				}
			});
		}
		function disableAutoVouchers() {
			loading.start();
			$.ajax({
				method: 'POST',
				url: '/disableAutomaticVouchers.ltr',
				success: function () {
					broker.trigger('REFRESH_BASKET_VIEW');
				},
				error: function () {
					modal.alert('Błąd deaktywacji. Spróbuj ponownie po odświeżeniu');
				}
			});
		}


		$('.js-enable-auto-vouchers', $self).click(function () {
			enableAutoVouchers();
		});
		$('.js-disable-auto-vouchers', $self).click(function () {
			disableAutoVouchers();
		});

		$('.js-warranty-add', $self).click(function (event) {
			event.preventDefault();
			event.stopPropagation();
			const $button = $(this).closest('.warranty');
			basketWarranty.add({
				mainCartItemId: $button.data('cart-id'),
				warrantyId: $button.data('id'),
				packageIdentifier: $button.data('package-identifier'),
				relatedPromotionIdentifier: $button.data('related-promotion-identifier'),
				warrantyPaymentType: $button.data('type'),
				warrantyName: $button.data('name'),
				warrantyPrice: $button.data('price'),
				warrantyQuantity: $button.data('quantity'),
				quantity: $button.data('quantity'),
				productPlu: $button.data('product-plu'),
				isProductInstallmentPrice: isProductInstallmentPrice($button.data('product-id')),
				place: 'promoted_warranty'
			});
		});

		$('.js-warranty-edit', $self).click(function (event) {
			event.preventDefault();
			if (!event.target.closest(`.js-show-tooltip`)) {
				var $this = $(this);
				const gradeInfoFromCartElement = event.target.closest('.js-warranty-grades-info-from-cart');
				const showGradeInfoFromCart = gradeInfoFromCartElement ? true : false;
				const categoryGradeInfoFromCart = $(gradeInfoFromCartElement).data('warranty-category');
				basketWarranty.open({
					productId: $this.data('product-id'),
					productPlu: $this.data('product-plu'),
					packageIdentifier: $this.data('package-identifier'),
					relatedPromotionIdentifier: $this.data('related-promotion-identifier'),
					mainCartItemId: $this.data('cart-id'),
					variant: $this.data('type'),
					defaultSelectedWarranty: !$this.hasClass('selected') && !$(event.target).closest(`.js-modal-warranty-info`).length ? $this.data('id') : false,
					showGradeInfoFromCart: showGradeInfoFromCart,
					categoryGradeInfoFromCart: categoryGradeInfoFromCart,
					isProductInstallmentPrice: isProductInstallmentPrice($this.data('product-id'))
				});
				if (showGradeInfoFromCart) {
					UA.interaction('Koszyk - K1', 'Gwiazdki przy wariancie PG', 'Kliknięcie');
				}
			}
		});

		$('.js-load-partner-subscriptions', $self).click(function (event) {
			partnerSubscriptionManager.load({
				group: $(this).data('group'),
				product: $(this).data('product'),
				productPlu: $(this).data('product-plu'),
				relatedPromotionIdentifier: $(this).data('related-promotion-identifier'),
				added: $(this).data('added').split('|').map(item => {
					return { id: item.slice(0, item.indexOf(':')), quantity: Number(item.slice(item.indexOf(':') + 1)) }
				})
			});
			event.preventDefault();
		});

		setPromotionProposalsUA();

		$('.js-subscription-tooltip').on('click', function (event) {
			const tooltipHtml = $(this).next('.js-warranty-period-info-subscription').html();
			modal.alert(tooltipHtml);
			event.stopPropagation();
		});

		$('.js-confirm-delete-esd', $self).on('click', function () {
			basketProduct.remove($(this).data('product'));
		});

		$('.js-show-warranties', $self).on('click', function (event) {
			log.event({
				id: "Przedluz gwarancje K1",
				f03: "Wiecej o ubezpieczeniu",
				f04: $(this).data('warranty-type') == 'ONE_TIME' ? "Płatność jednorazowa" : "Płatność miesięczna",
				f05: ""
			});
		});

		$('.js-basket-next', $self).on('click', function () {
			next();
		});
		$('.js-basket-back, .js-cart-delivery-back', $self).on('click', function () {
			back();
		});
		if (config.activeInstalmentOrderNumber) {
			log.event({
				id: 'creditline_application_ongoing',
				f03: 'empty-cart',
				f04: 'wyświetlenie sekcji o niedokończonym wniosku'
			});
		}
		$('.js-finish-last-creditline-application', $self).on('click', function () {
			const orderNumber = config.activeInstalmentOrderNumber;
			log.event({
				id: 'creditline_application_ongoing',
				f03: 'empty-cart',
				f04: 'kliknięcie przycisku dokończ wniosek',
			});
			if (orderNumber) {
				csrfToken.get(function (csrf_token) {
					kredytLineRedirect.redirect({
						'orderNumber': orderNumber,
						'_csrf': csrf_token
					}, {
						timeout: config.nklTimeout,
						revisions: config.nklRevisions
					});
				});
			}
		});
		$('.js-go-to-account-link', $self).on('click', function () {
			log.event({
				id: 'creditline_application_ongoing',
				f03: 'empty-cart',
				f04: 'kliknięcie przycisku przejdź do wszystkich wniosków',
			});
		});
		$('.js-delete-product', $self).on('click', function () {
			const index = $(this).closest('.product-box').index();
			basketProduct.remove($(this).data('main'), $(this).data('bundle-remove'), $(this).data('dependent-remove'), {type: 'remove-product', index: index});
		});
		$('.js-delete-suite', $self).on('click', function () {
			const suite = $(this).data('suite');
			const index = $(this).closest('.package-box').index();
			basketProduct.removeSuite(suite, { type: 'remove-suite', index: index });
		});


		$('.js-change-quantity', $self).change(function (event) {
			event.preventDefault();
			const value = $(this).val() / 1;
			const mainId = $(this).data('main');
			const bundle = $(this).data('bundle-limit');
			const quantity = $(this).data('quantity') / 1;
			const max = $(this).data('max') / 1;
			const maxProduct = $(this).data('max-product') / 1;
			if (value > 0 && value <= max) {
				basketProduct.change(value, mainId, { type: 'change-quantity', main: mainId });
			} else if (value > max) {
				showMaxCountMessage(maxProduct, mainId, bundle);
				$(this).val(quantity);
			} else {
				$(this).val(quantity);
			}
		});
		$('.js-change-partner-subscription-quantity', $self).change(function () {
			const quantity = $(this).val();
			const mainId = $(this).data('main');
			const partnerSubscriptionId = $(this).data('partner-subscription');

			basketPartnerSubscription.update({
				productId,
				partnerSubscriptionId,
				quantity
			});
		});
		$('.js-change-partner-subscription-standalone-service-quantity', $self).change(function () {
			const quantity = $(this).val();
			const productId = $(this).data('product-id');
			basketStandaloneService.update({
				productId,
				quantity
			});
		});
		$('.js-delete-partner-subscription', $self).click(function () {
			loading.start();
			const productId = $(this).data('main');
			const partnerSubscriptionId = $(this).data('partner-subscription');

			basketPartnerSubscription.remove({
				productId,
				partnerSubscriptionId
			});
		});

		$('.js-all-accessories-modal', $self).on('click', function () {
			allAccesoriesModal.open($(this).data('product-id'), $(this).data('link'));
		});

		expandableMessage.init();

		$('.js-change-service-quantity', $self).on('change', function () {
			const quantity = $(this).val();
			const mainItemId = $(this).data('main-item-id');
			const serviceId = $(this).data('service');

			basketServices.change({
				mainItemId,
				serviceId,
				quantity
			});
		});

		$('.js-services-group', $self).on('click', function (event) {
			if (!event.target.closest(`.js-show-tooltip`)) {
				basketServices.open({
					mainItemId: $(this).data('main-item-id') / 1,
					productId: $(this).data('product-id') / 1,
					productPlu: $(this).data('product-plu') / 1,
					groupId: $(this).data('group-id') / 1,
					groupPromoted: $(this).data('group-promoted'),
					packageIdentifier: $(this).data('package-identifier') / 1,
					version: $(this).data('version'),
					group: $(this).data('group') / 1,
					index: $(this).data('index') / 1,
					added: ('' + $(this).data('added')).split('|').map((element) => {
						var elementSplit = element.split(':');
						return {
							id: elementSplit[0],
							quantity: elementSplit[1],
							plu: elementSplit[2],
							mainItemId: elementSplit[3],
							productPlu: elementSplit[4]
						};
					}),
					paymentType: basket.items.filter(item => item.id == $(this).data('product-id') / 1)[0].isInstalmentPrice ? 'installment' : 'cash',
				});
			}
			event.preventDefault();
		});

		$('.js-add-one-service', $self).on('click', function (event) {
			event.preventDefault();
			event.stopPropagation();
			loading.start();
			const $button = $(this).closest('.services-group');
			basketServices.add({
				mainItemId: $button.data('main-item-id'),
				serviceId: $(this).data('service-id'),
				servicePlu: $(this).data('service-plu'),
				productPlu: $button.data('product-plu'),
				noReload: true,
				quantity: $button.data('quantity') || 1,
				callback: function(){
					broker.trigger('REFRESH_BASKET_VIEW');
				}
			});
		});
		$('.js-remove-one-service', $self).on('click', function (event) {
			event.preventDefault();
			event.stopPropagation();
			loading.start();
			const $button = $(this).closest('.services-group');
			basketServices.remove({
				mainItemId: $button.data('main-item-id'),
				serviceId: $(this).data('service-id'),
				servicePlu: $(this).data('service-plu'),
				productPlu: $button.data('product-plu'),
				noReload: true,
				quantity: $button.data('quantity') || 1,
				callback: function(){
					broker.trigger('REFRESH_BASKET_VIEW');
				}
			});
		});

		$('.js-service-description', $self).on('click', function (event) {
			basketServices.info($(this).data('service'), $(this).data('product'));
			event.preventDefault();
			event.stopPropagation();
		});

		$('.js-change-warranty-quantity', $self).on('change', function () {
			const value = $(this).val();
			const mainItemId = $(this).data('main-item-id');
			basketWarranty.change(value, mainItemId);
		});

		$('.js-show-more-services').on('click', function () {
			let $parent = $(this).closest('.product-item');
			$parent.toggleClass('full-list');
			if ($parent.hasClass('full-list')) {
				$parent.find('.checkbox-css:nth-child(2)').focus();
			}
		});
		$('#modal-basket-services-changed').on('closed', function () {
			send();
		});

		$deliveryType.on('click', function () {
			setShopPaymentType($(this).data('shop-payment-type'));
			updateDeliveryType($(this).val());
		});

		$('.js-set-product-voucher', $self).on('click', function () {
			const voucherCode = $(this).data('voucher-code');
			if (voucherCode) {
				basketVoucher.activateVoucherByCode(String(voucherCode));
			}
		});

		validate.task('basket');
	}

	function removeWrongServices(callback) {
		console.log('Usuwanie niezgodnych usług');
		loading.start();
		$.ajax({
			url: '/cartActions.ltr',
			method: 'post',
			data: {
				action: 'REMOVE_INVALID_SERVICES',
				//deliveryType: daliveryType		// nie wysyłać deliveryType gdy usuwamy usługi z obecną dostawą
			},
			success: function () {
				if (callback) {
					callback();
				}
			},
			error: function () {
				loading.stop();
				modal.alert('Błąd usuwania usług. Strona zostanie odświeżona', function () {
					loading.reload();
				})
			}
		});
	}

	function deliveryReset() {
		loading.start();
		$.ajax({
			url: '/cart-reset-delivery-type.ltr',
			method: 'post',
			success: function () {
				reloadCartView();
			},
			error: function () {
				loading.stop();
			}
		});
	}
	function init() {
		console.log('INIT BASKET');
		setElements();
		setEvents();
		if (!isOneInit) {
			isOneInit = true;
			broker.on('REFRESH_BASKET_VIEW', function (event, focusParams) {
				if (focusParams) {
					savedFocusParams = focusParams;					// zapisuje focusParams do wykorzystania po przeładowaniu koszyka, ponieważ w momencie wywołania tego eventu koszyk jeszcze się nie przeładował i nie można od razu ustawić focusa
				}
				reloadCartView();
			});
			broker.on('SUBMIT_BASKET_VIEW', function (e, focusParams) {
				loading.start();
				$form.ajaxSubmit({
					success: function (html) {
						if (focusParams) {
							savedFocusParams = focusParams;					// zapisuje focusParams do wykorzystania po przeładowaniu koszyka, ponieważ w momencie wywołania tego eventu koszyk jeszcze się nie przeładował i nie można od razu ustawić focusa
						}
						reloadCartSuccess($('<div>' + html + '</div>').find('#container').html(), null);
					},
					error: function () {
						modal.alert('Wykonanie operacji okazało się niemożliwe. Strona zostanie przeładowana. Spróbuj ponownie', function () {
							loading.reload();
						});
					}
				});
			});
			broker.on('CONFIRM_HOME_DELIVERY', function () {
				// Zamów do domu, z usługami															// to podejście zostało czasowo zlikwidowane, nowe robi tylko jednego posta przez co jest wydajniejsze. Jeśli nowe się sprawdzi to będzie można stare posprzątać
				// reloadDelivery('CHANGE_DELIVERY_TYPE', 1, function(){	// akcja zmiany dostawy
				// 	next();												// wysyła ponownie koszyk
				// });
				$deliveryType.prop('checked', false).filter('[value=1]').prop('checked', true);
				setShopPaymentType('');
				orderUtils.send('CHANGE_DELIVERY_TYPE_AND_CREATE_ORDER');

			});
			broker.on('RESIGN_HOME_DELIVERY', function () {
				// Zarezerwuj w sklepie, z usługami														// to podejście zostało czasowo zlikwidowane, nowe robi tylko jednego posta przez co jest wydajniejsze. Jeśli nowe się sprawdzi to będzie można stare posprzątać
				// reloadDelivery('CHANGE_DELIVERY_TYPE', 0, function(){	// akcja zmiany dostawy
				// 	next();												// wysyła ponownie koszyk
				// });
				$deliveryType.prop('checked', false);
				let $shop = $('label:visible .js-delivery-type').filter('[value=0]').not(':disabled').first();
				$shop.prop('checked', true);
				setShopPaymentType($shop.data('shop-payment-type'));
				orderUtils.send('CHANGE_DELIVERY_TYPE_AND_CREATE_ORDER');
			});
			broker.on('DECLINE_HOME_DELIVERY', function () {
				// Zamów do domu, bez usług
				removeWrongServices(function () {		// usuwa złe usługi
					reloadCartView(function () {		// odświeża stan koszyka
						next();						// wysyła ponownie koszyk
					})
				})
			});

			broker.on('ORDER-NEXT-STEP', function () {
				if ($('.js-basket-next').length && pageConfig.getData('order').pageType == 'basket') {
					next();
				}
			});
			$('body').on('click', '.js-service-change-confirm', function (event) {
				basketServices.save();
				event.preventDefault();
			}).on('change', '.remodal-right .js-service-quantity', function (event) {	// po teście nowej ścieżki trzeba lepiej nałożyć zdarzenia na właściwy modal
				event.preventDefault();
				const $serviceItem = $(this).closest('.service-item');
				basketServicesModal.inputChange($serviceItem.data('service'), $serviceItem.data('product'));
			}).on('click', '.js-service-modal-decrease', function (event) {
				event.preventDefault();
				const $serviceItem = $(this).closest('.service-item');
				basketServicesModal.decrease($serviceItem.data('service'), $serviceItem.data('product'));
			}).on('click', '.js-service-modal-increase', function (event) {
				event.preventDefault();
				const $serviceItem = $(this).closest('.service-item');
				basketServicesModal.increase($serviceItem.data('service'), $serviceItem.data('product'));
			}).on('click', '.js-service-modal-add', function (event) {
				event.preventDefault();
				const $serviceItem = $(this).closest('.service-item');
				basketServicesModal.add($serviceItem.data('service'), $serviceItem.data('product'));
			}).on('click', '.js-service-modal-change', function (event) {
				event.preventDefault();
				const $serviceItem = $(this).closest('.service-item');
				basketServicesModal.change($serviceItem.data('service'), $serviceItem.data('product'));
			}).on('click', '.js-service-modal-remove', function (event) {
				event.preventDefault();
				const $serviceItem = $(this).closest('.service-item');
				basketServicesModal.remove($serviceItem.data('service'), $serviceItem.data('product'));
			}).on('click', '.js-service-modal-details', function (event) {
				const $serviceItem = $(this).closest('.service-item');
				basketServicesModal.showDetails($serviceItem.data('service'), $serviceItem.data('product'));
				event.preventDefault();
			}).on('click', '.js-toggle-services', function (event) {
				basketServicesModal.toggleServices($(this).data('product'));
				event.preventDefault();
			}).on('click', '.js-show-instalment-calculator', function () {
				instalmentCalculatorModal.open();
			}).on('click', '.js-voucher-info', function () {
				const dataModal = $(this).data('modal');
				if (dataModal) {
					modal.open(dataModal);
				}
			}).on('click', '.js-tooltip-taxfree', function () {
				const lang = $(this).data('lang');
				const messageCode = $(this).data('message');
				message.get(messageCode).then(function (result) {
					modal.generate({
						id: 'modal-taxfree-info',
						content: result,
						lang: lang
					});
				});
			}).on('click', '.js-native-app-order-more-actions-button', function () {
				$('.js-native-app-order-more-actions-list').toggleClass('active');
			}).on('click', function (event) {
				if (!event.target.closest('.js-native-app-order-more-actions-button')) {
					$('.js-native-app-order-more-actions-list').removeClass('active');
				}
			});
			if(document.hash && document.hash.indexOf('#energy-card-') === 0) {
				$('.product-energy[data-plu="' + document.hash.replace('#energy-card-', '') + '"] .js-energy-card').first().trigger('click');
			} else if(document.hash && document.hash.indexOf('#energy-modal-') === 0) {
				$('.product-energy[data-plu="' + document.hash.replace('#energy-modal-', '') + '"] .js-energy-label').first().trigger('click');
			}
			basketAnalytics.sendAll();
		}
		if (savedFocusParams) {
			basketFocus.focusAndScroll(savedFocusParams);
			savedFocusParams = false;
		} else {
			console.log('Nie robimy focusa po inicjalizacji koszyka, ponieważ nie otrzymaliśmy parametrów focusa');
		}
		if (!config.deliveryMode && html.has('new-delivery') && config.deliveryTypeName === 'shop' && (config.isInstalmentPayment || !config.instalmentPossible)) {
			deliveryReset();
		}
		if (!config.deliveryMode && html.has('new-delivery') && config.isInstalmentPayment) {
			const header = $('#preview-list .user-instalment-option-changed-message').text();
			const content = $('#invalid-dynamic-including-instalment-option').html();
			if(header){
				simpleToastr.generate(`<h2>${header}</h2>` + (content ? `<p>${content}</p>` : ''), {
					modifier: 'message'
				});
			}
		}
		operatorMaxWorthCalculator.init();
		basketDependentProduct.init();
		partnerInsurance.init();
		basketVoucher.init();
		basketBundle.init();
		basketServiceReminder.init();
		newBasketServiceReminder.init();
		basketAccessories.init();
		basketRetrieveCart.init();
		basketHomeDelivery.init();
		basketDeliveryUnavailable.init();
		instalmentOrderAction.init(closeInstalmentOrdersAction);
		if (config.esdDelayed) {
			modal.open('esd-delayed-message');
		} else if (config.showInvalidItemWithIncludedPackageItemsMessage) {
			modal.open('invalid-package-items-included');
		} else if (config.showCartPopupMessage) {
			modal.open('cart-popup-message');
		}
		if (html.has('new-delivery') && !config.deliveryMode) {
			$('.js-delivery-type').ignore(true);		// na koszyku wyłączamy walidację sposobów dostawy dla nowego koszyka.
		}
		if (html.has('points-on-delivery') && config.deliveryMode && (config.deliveryTypeName === 'shop' || config.deliveryTypeName === 'inpost' || config.deliveryTypeName === 'pickupPoint')) {
			deliveryPoints.init();
			if (!config.deliveryPoint) {
				deliveryPoints.show();
			}
		}
		UA.push({
			ppg: {
				positions: config.pluQuantity,
				products: config.productsQuantity
			}
		});

		showMessages();
		cartRetrieve.checkIfBundleModal();
		if (config.voucherErrorMessage?.length) {
			simpleToastr.generate(config.voucherErrorMessage, {
				closeOthers: true,
				modifier: 'warning'
			});
		} else if (config.voucherInfoMessage?.length) {
			simpleToastr.generate(config.voucherInfoMessage, {
				closeOthers: true
			});
		}
		const $bundleToastrMessage = $('#bundle-toastr-message');
		if ($bundleToastrMessage.length) {
			simpleToastr.generate($bundleToastrMessage.html());
		}
		const selectedVoucherCode = config.selectedVoucherCode;
		if(selectedVoucherCode && selectedVoucherCode.length > 3) {
			basketVoucher.checkAfterLogin(selectedVoucherCode);
		}
	}

	return {
		init,
		next
	};
});
